/**
 * E10. Ломбард и микрозайм: две кнопки с суммой и тем, сколько вернуть
 * через год; «не занимать» — это «Пропустить» каркаса.
 */
import { t } from '@life/i18n';
import type { LoansInput, LoansState } from '@life/minigames';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';

export function Loans({ state, onInput }: MinigameScreenProps<LoansInput, LoansState>) {
  return (
    <div class="picks column">
      <button type="button" class="btn" disabled={!(state.pawnAmount > 0)} onClick={() => onInput({ kind: 'pawn' })}>
        {t('ui.minigame.loans.pawn', { sum: money(state.pawnAmount), due: money(state.pawnDue) })}
      </button>
      <button type="button" class="btn" disabled={!(state.microAmount > 0)} onClick={() => onInput({ kind: 'microloan' })}>
        {t('ui.minigame.loans.micro', { sum: money(state.microAmount), due: money(state.microDue) })}
      </button>
    </div>
  );
}
